export default __webpack_public_path__ + "static/media/Sansita-BlackItalic.b9f7d159.ttf";